import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface PlayPauseFlashMessageResponse extends MiddlewareAPIResponse
{
   
}

export class PlayPauseFlashMessageResponseDtoImpl extends MiddlewareDtoImpl implements PlayPauseFlashMessageResponse
{
   
    
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/playpause/playpuaseflashmessagesresponse.tsx